import { render, staticRenderFns } from "./MsgElementQuestion.vue?vue&type=template&id=4cc0c6c8"
import script from "./MsgElementQuestion.vue?vue&type=script&lang=js"
export * from "./MsgElementQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports